import { Routes } from '@angular/router';
import { PickupTargetStateItem } from '../../states/pickup-target.state-item';
import { PICKUP_CONFIG } from './base/pickup-config';

export const pickupRoutes: Routes = [
  {
    path: PICKUP_CONFIG.routePath,
    providers: [PickupTargetStateItem],
    loadComponent: () =>
      import(
        './components/smart/pickup-assign-page/pickup-assign-page.component'
      ).then((m) => m.PickupAssignPageComponent),
    children: [
      {
        path: 'calendar/:fromDate/:toDate/:mrhstId',
        loadComponent: () =>
          import(
            './components/smart/pickup-calendar-page/pickup-calendar-page.component'
          ).then((m) => m.PickupCalendarPageComponent),
        children: [
          {
            path: 'searchday/:searchDay/:pickupType',
            loadComponent: () =>
              import(
                './components/smart/pickup-info-page/pickup-info-page.component'
              ).then((m) => m.PickupInfoPageComponent),
            data: {
              title: 'Pickup',
            },
          },
        ],
      },
    ],
  },
];
